import Vue from 'vue'
import Router from 'vue-router'
// import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/404',
      name: '404',
      component: () => import('./views/NotFound')
    },
    {
      // Here's the new catch all route
      path: '*',
      redirect: { name: 'home' }
    },
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "about" */ './views/Knowledge.vue')
      // component: () => import('./views/Home')
    },
    {
      path: '/knowledge/:knowledgeId',
      name: 'knowledge-detail',
      component: () => import(/* webpackChunkName: "about" */ './views/KnowledgeDetail.vue')
    },
    {
      path: '/knowledge/:knowledgeId/exam',
      name: 'exam',
      component: () => import(/* webpackChunkName: "about" */ './views/Exam.vue')
    },
    {
      path: '/internship',
      name: 'internship',
      component: () => import(/* webpackChunkName: "about" */ './views/Internship.vue')
    },
    // End main page
    {
      path: '/content/:postId',
      name: 'content',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Content.vue')
    },
    {
      path: '/content/:postId/register',
      name: 'content-register',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/ContentRegister.vue')
    }
  ]
})

// router.beforeEach((to, from, next) => {
//   // console.log(to);
//   // console.log(store.state.Product.searchProductId);
//   // console.log(to.matched.some(record => record.meta.requiresAuth))
//   // if (to.matched.some(record => record.meta.requiresAuth)) {
//   //   if (store.state.Product.searchProductId) {
//   //     next()
//   //     // }
//   //   } else {
//   //     next({
//   //       name: 'home'
//   //     })
//   //   }
//   // } else {
//   //   next() // make sure to always call next()!
//   // }
// })

export default router
